import i18n from './i18n.js';
const mobilePrefix = '852';
export const companies = [
    // 元朗
    {name: i18n.t('company1'), isMain: true, ename: 'Yuen Long', addr: i18n.t('addr1'), addr1: i18n.t('addr11'), persons: [
        {name: 'Jenny', role: i18n.t('director'), mobilePrefix, mobile: '5160 4299', email: 'doc@goldenwin.com.hk'},
        // {name: 'Roy', role: i18n.t('assistance'), mobilePrefix, mobile: '9133 4460', email: ''},
        {name: 'Koty', role: i18n.t('secretary'), mobilePrefix, mobile: '6131 3331', email: ''},
    ], center: [114.033479,22.438698], url: 'Maps_1LongPing.jpg'},
    // 天水園
    // {name: i18n.t('company3'), ename: 'Tin Shui Wai', addr: i18n.t('addr3'), addr1: i18n.t('addr31'), person: 'Jenny', role: i18n.t('director'), mobilePrefix, mobile: '5160 4299', email: 'Tinshuiwai@goldenwin.com.hk', center: [114.008285,22.461818], url:'Maps_2Tin Sau.jpg'},
    // 大埔
    // {name: i18n.t('company2'), ename: 'Taipo', addr: i18n.t('addr2'), addr1: i18n.t('addr21'), person: 'Katherine', role: i18n.t('consultant'), mobilePrefix, mobile: '6156 7020', phone: '2777 6777', email: 'taipo@goldenwin.com.hk', center: [114.171902,22.445767], url: 'Maps_4TaiPoMarket.jpg'},
    // 筲箕灣
    // {name: i18n.t('company4'),ename: 'Shau Kei Wan', addr: i18n.t('addr4'), addr1: i18n.t('addr41'), persons: [
    //     {name: 'Daisy', role: i18n.t('consultant'), mobilePrefix, mobile: '6825 3702', phone: '2988 8428', email: 'Shaukeiwan@goldenwin.com.hk'},
    // ], center: [114.231003,22.275076], url: 'Maps_3ShauKeiWan.jpg'},
    // 觀塘
    // {name: i18n.t('company5'), ename: 'Kwun Tong', addr: i18n.t('addr5'), addr1: i18n.t('addr51'), person: 'Cookie', role: i18n.t('consultant'), mobilePrefix, mobile: '5689 9456', phone: '2322 8748', email: 'kwuntong@goldenwin.com.hk', center: [114.229642,22.307555], url: 'Maps_5KwunTong.jpg'},
    // 尖沙咀
    // {name: i18n.t('company6'), ename: 'Tsim Sha Tsui', addr: i18n.t('addr6'), addr1: i18n.t('addr61'), person: 'Tracy', role: i18n.t('consultant'), mobilePrefix, mobile: '6619 1899', phone: '2391 3122', email: 'Tsimshatsui@goldenwin.com.hk', center: [114.229642,22.307555], url: 'Maps_6EastTST.jpg'},
    // 長沙灣
    // {name: i18n.t('company7'), ename: 'Cheung Sha Wan', addr: i18n.t('addr7'), addr1: i18n.t('addr71'), person: 'Roy', role: i18n.t('consultant'), mobilePrefix, mobile: '9133 4460', phone: '2383 6328', email: 'Cheungshawan@goldenwin.com.hk', center: [114.229642,22.307555], url: 'Maps_7LaiChiKok.jpg'},
    // 灣仔分行
    // {name: i18n.t('company8'), ename: 'Branch: Wan Chai', addr: i18n.t('addr8'), addr1: i18n.t('addr81'), person: 'Carrie', role: i18n.t('consultant'), mobilePrefix, mobile: '5112 6775', email: 'wanchai@goldenwin.com.hk', center: [114.229642,22.307555], url: 'Maps_8WanChai.jpg'},
];

export const priceMap = {
    1: 15380, //12980, ex-Asia
    2: 15380, //11980, ex-Mideast
    3: 15380 , // 10980, first time
    4: 15380, // 10800, direct hire over
    5: 1680, //1680 renew
    6: 6980, //4980 Direct finish
};
export const newPriceMap = {
    1: 15380, //1.Additional helper
    2: 15380, //2.New Client
    3: 0 , //3.Replacement:Helper no yet come HK
    4: 15380, //4.Replacement:Over 14 Months
    5: 0, //5.Replacement:Within 7 months Confirm new helper from the day of start work
    6: 6980, //6.Replacement:From 8 months till 14 months before confirm new helper
};
